var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-page-wrap" },
    [
      _vm.customConfig.bizType == 3 ? _c("lease") : _vm._e(),
      _vm._v(" "),
      _vm.customConfig.bizType == 1 ? _c("normal") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }